export enum ModalType {
  ADD = 'ADD',
  EDIT = 'EDIT',
}
